import React from 'react';
import { motion } from 'framer-motion';
import { FaFire, FaHeart, FaStar, FaGem, FaCrown, FaBolt, FaMoon, FaSun } from 'react-icons/fa';

const badgeTypes = {
  streak: {
    icon: FaFire,
    color: '#FF5722',
    label: 'Streak',
    description: 'Jours consécutifs de conversation'
  },
  newMatch: {
    icon: FaHeart,
    color: '#E91E63',
    label: 'Nouveau Match',
    description: 'Vous venez de matcher !'
  },
  vip: {
    icon: FaCrown,
    color: '#FFD700',
    label: 'VIP',
    description: 'Utilisateur premium'
  },
  active: {
    icon: FaBolt,
    color: '#00BCD4',
    label: 'Très actif',
    description: 'Répond rapidement'
  },
  nightOwl: {
    icon: FaMoon,
    color: '#673AB7',
    label: 'Couche-tard',
    description: 'Actif la nuit'
  },
  earlyBird: {
    icon: FaSun,
    color: '#FF9800',
    label: 'Lève-tôt',
    description: 'Actif le matin'
  },
  gem: {
    icon: FaGem,
    color: '#3F51B5',
    label: 'Gemme',
    description: 'Profil très apprécié'
  },
  star: {
    icon: FaStar,
    color: '#FFC107',
    label: 'Star',
    description: 'Populaire'
  }
};

const ConversationBadge = ({ type, value }) => {
  const badge = badgeTypes[type];
  if (!badge) return null;

  const Icon = badge.icon;

  return (
    <motion.div
      className="conversation-badge"
      style={{ '--badge-color': badge.color }}
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.1 }}
      title={badge.description}
    >
      <Icon className="badge-icon" />
      <span className="badge-label">{badge.label}</span>
      {value && <span className="badge-value">{value}</span>}
    </motion.div>
  );
};

const ConversationBadges = ({ badges }) => {
  if (!badges || badges.length === 0) return null;

  return (
    <div className="conversation-badges">
      {badges.map((badge, index) => (
        <motion.div
          key={badge.type}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <ConversationBadge type={badge.type} value={badge.value} />
        </motion.div>
      ))}
    </div>
  );
};

export { ConversationBadge, badgeTypes };
export default ConversationBadges;
